module.exports = __webpack_public_path__ + "static/uzoma-b8a149bfebdd8f0b30913faa6e79dc33.png";